<template>
  <div class="page">
    <h1>Datenschutzerklärung</h1>
    <p>TODO</p>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.page{max-width:900px;margin:40px auto;padding:0 16px;color:#fff}
h1{margin-bottom:16px}
h2{margin-top:24px}
</style>
